import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PrivateHeader } from "../Components/HomePage/PrivateHeader/PrivateHeader";
import { Tasks } from "./Tasks";
import { ValidationQRCode } from "../../Components/ModelWindows/SignInSteps/QRCodeValidationModel";
import { ModelUpdateQRCode } from "../../Components/ModelUpdateQRCode/ModelUpdateQRCode";
import { ConfirmEmailModel } from "../../Components/ModelWindows/SignUpSteps/ConfirmEmail/ConfirmEmail";
import { AddQRCodeModel } from "../../Components/ModelWindows/SignUpSteps/AddQRCode/AddQRCodeModel";

export const HomePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // ---------- 1️⃣ Sign In → QR Code ----------
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);
  const [isOpenQRCode, setIsOpenQRCode] = useState(false);

  // ---------- 2️⃣ Sign Up → Confirm Email ----------
  const [showConfirmEmail, setShowConfirmEmail] = useState(
    localStorage.getItem("showConfirmEmail") === "true"
  );
  const [isOpenModal, setIsOpenModal] = useState(false);

  // ---------- 3️⃣ Sign Up → Add QR Code ----------
  const [showAddQRCode, setShowAddQRCode] = useState(
    localStorage.getItem("showAddQRCode") === "true"
  );

  // ---------- 🧠 Open / Close Logic ----------

  // --- Sign In QR modal ---
  const openQRCodeModal = () => {
    // закриваємо інші модалки
    localStorage.setItem("showConfirmEmail", "false");
    localStorage.setItem("showAddQRCode", "false");
    setShowConfirmEmail(false);
    setShowAddQRCode(false);

    setShowQRCodeModal(true);
    setTimeout(() => setIsOpenQRCode(true), 0);
    localStorage.setItem("showQRCodeModal", "true");
  };

  const closeQRCodeModal = () => {
    setIsOpenQRCode(false);
    setTimeout(() => setShowQRCodeModal(false), 250);
    localStorage.setItem("showQRCodeModal", "false");
  };

  // --- Confirm Email modal ---
  const openConfirmEmail = () => {
    localStorage.setItem("showQRCodeModal", "false");
    setShowQRCodeModal(false);

    setShowConfirmEmail(true);
    setTimeout(() => setIsOpenModal(true), 0);
    localStorage.setItem("showConfirmEmail", "true");
  };

  const closeConfirmEmail = () => {
    setIsOpenModal(false);
    setTimeout(() => {
      setShowConfirmEmail(false);
      localStorage.setItem("showConfirmEmail", "false");

      // 🟢 після підтвердження email — відкриваємо Add QR Code
      openAddQRCode();
    }, 250);
  };

  // --- Add QR Code modal ---
  const openAddQRCode = () => {
    localStorage.setItem("showAddQRCode", "true");
    setShowAddQRCode(true);
    setTimeout(() => setIsOpenModal(true), 0);
  };

  const closeAddQRCode = () => {
    setIsOpenModal(false);
    setTimeout(() => setShowAddQRCode(false), 250);
    localStorage.setItem("showAddQRCode", "false");
  };

  // ---------- 🔁 Handle redirects (from SignIn / SignUp) ----------
  useEffect(() => {
    // Якщо прийшли з Sign Up — відкриваємо Confirm Email
    if (location.state?.openConfirmEmailModal) {
      localStorage.removeItem("showQRCodeModal");
      openConfirmEmail();
      navigate(location.pathname, { replace: true, state: {} });
    }

    // Якщо прийшли з Sign In — відкриваємо QR Validation
    if (location.state?.openQRCodeModal) {
      localStorage.removeItem("showConfirmEmail");
      openQRCodeModal();
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  // ---------- ♻️ Restore modals after refresh ----------
  useEffect(() => {
    if (localStorage.getItem("showConfirmEmail") === "true") {
      openConfirmEmail();
    } else if (localStorage.getItem("showAddQRCode") === "true") {
      openAddQRCode();
    } else if (localStorage.getItem("showQRCodeModal") === "true") {
      openQRCodeModal();
    }
  }, []);

  // ---------- 🧩 Render ----------
  return (
    <>
      <PrivateHeader />
      <Tasks />

      {/* Sign In — QR Validation */}
      {showQRCodeModal && (
        <ModelUpdateQRCode onClose={closeQRCodeModal} isOpen={isOpenQRCode}>
          <ValidationQRCode onClose={closeQRCodeModal} />
        </ModelUpdateQRCode>
      )}

      {/* Sign Up Step 1 — Confirm Email */}
      {showConfirmEmail && (
        <ModelUpdateQRCode onClose={closeConfirmEmail} isOpen={isOpenModal}>
          <ConfirmEmailModel
            onNext={() => {
              closeConfirmEmail(); // закриваємо ConfirmEmail
              setTimeout(() => openAddQRCode(), 300); // відкриваємо AddQRCode
            }}
          />
        </ModelUpdateQRCode>
      )}

      {/* Sign Up Step 2 — Add QR Code */}
      {showAddQRCode && (
        <ModelUpdateQRCode onClose={closeAddQRCode} isOpen={isOpenModal}>
          <AddQRCodeModel onClose={closeAddQRCode} />
        </ModelUpdateQRCode>
      )}
    </>
  );
};
